<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
  <div class="move-subject">
    <span class="move-subject-label">{{ 'settings.documentTemplate.move.subject' | translate }}</span>
    <strong>{{ data.subject }}</strong>
  </div>
  <div class="move-current" *ngIf="data.currentLabel">
    <span class="move-subject-label">{{ 'settings.documentTemplate.move.currentParent' | translate }}</span>
    {{ data.currentLabel }}
  </div>

  <div class="move-warning" role="alert">
    <mat-icon fontSet="fal" fontIcon="fa-exclamation-triangle"></mat-icon>
    <span>{{ data.warning }}</span>
  </div>

  <ng-container *ngIf="hasDestinations; else noDestinations">
    <mat-form-field class="w-100">
      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="search"
        (ngModelChange)="applySearch()"
        [placeholder]="'common.words.search' | translate">
      <mat-icon matSuffix fontSet="fal" fontIcon="fa-search"></mat-icon>
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>{{ data.selectLabel }}</mat-label>
      <mat-select [(ngModel)]="selectedValue" required>
        <ng-container *ngFor="let group of visibleGroups">
          <mat-optgroup *ngIf="group.label" [label]="group.label">
            <mat-option
              *ngFor="let option of group.options"
              [value]="option.value"
              [disabled]="option.disabled">
              {{ option.label }}
              <small class="move-option-hint" *ngIf="option.hint">({{ option.hint }})</small>
            </mat-option>
          </mat-optgroup>
          <ng-container *ngIf="!group.label">
            <mat-option
              *ngFor="let option of group.options"
              [value]="option.value"
              [disabled]="option.disabled">
              {{ option.label }}
              <small class="move-option-hint" *ngIf="option.hint">({{ option.hint }})</small>
            </mat-option>
          </ng-container>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <div class="move-empty-search" *ngIf="visibleGroups.length === 0">
      {{ 'common.words.no_search_results' | translate }}
    </div>
  </ng-container>

  <ng-template #noDestinations>
    <div class="move-empty-search">
      {{ 'settings.documentTemplate.move.noDestinations' | translate }}
    </div>
  </ng-template>
</mat-dialog-content>

<div class="row custom-dialog-footer">
  <div class="col-12 col-md-6 text-left">
    <a mat-raised-button color="warn" (click)="onClose()">
      <mat-icon fontSet="fal" fontIcon="fa-times-circle"></mat-icon>
      {{ 'common.cta.undo' | translate }}
    </a>
  </div> <!-- /.col -->
  <div class="col-12 col-md-6 text-right">
    <button
      mat-raised-button
      color="primary"
      [disabled]="!selectedValue"
      (click)="onConfirm()">
      <mat-icon fontSet="fal" fontIcon="fa-exchange"></mat-icon>
      {{ 'settings.documentTemplate.move.confirm' | translate }}
    </button>
  </div> <!-- /.col -->
</div> <!-- /.row -->
